import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import React, { useState } from 'react';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { cn } from '../../lib/utils';
const Carousel = ({ id, className, autoplay = false, autoplayDelay = 4000, slideElements, onSlideChange, ...props }) => {
    const [swiperInstance, setSwiperInstance] = useState(undefined);
    React.useEffect(() => {
        if (!swiperInstance)
            return;
        if (autoplay) {
            swiperInstance.params.autoplay = { delay: autoplayDelay };
            swiperInstance.autoplay.start();
        }
        else {
            swiperInstance.autoplay?.stop();
        }
    }, [swiperInstance, autoplay, autoplayDelay]);
    return (React.createElement(React.Fragment, null,
        React.createElement("style", null, `
          .swiper-slide-duplicate * {
            tab-index: -1 !important;
          }
        `),
        React.createElement(Swiper, { className: cn('w-full relative [&_.swiper-slide]:h-full', className), effect: undefined, loop: true, spaceBetween: 16, modules: [Pagination, Autoplay, EffectFade, Navigation], navigation: {
                nextEl: `.swiper-nav-next-${id}`,
                prevEl: `.swiper-nav-prev-${id}`,
            }, onSwiper: setSwiperInstance, ...(onSlideChange && { onSlideChange }), ...props }, slideElements.map((element, index) => (React.createElement(SwiperSlide, { key: element.key ?? index, className: "swiper-slide", role: "group", "aria-roledescription": "slide", "aria-label": `Slide ${index + 1} of ${slideElements.length}` },
            React.createElement("div", { tabIndex: 0, className: "h-full outline-none focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-500 rounded" }, element)))))));
};
export default Carousel;
